import { takeEvery, call, put, all, select } from 'redux-saga/es/effects';
import {
  sendRequest,
  requestInProcess,
  requestFinished,
  clearAllErrors,
  initState,
  selectFormBody
} from './reducer';

import { addItemToUp } from '../../../../../../common/reducers/list/reducer';

import { timeoutCall } from '../../../../../../utils/sagaHalper';
import MessengerService from '../../../../services/MessengerService';

function* sendMessageFormSaga(reducerName, action) {
  const formReducerName = `${reducerName}.sendMessageForm`;
  const listReducerName = `${reducerName}.list`;

  yield put(requestInProcess(formReducerName));
  const formBody = yield select(selectFormBody, formReducerName);
  try {
    yield put(clearAllErrors(formReducerName));

    const result = yield call(
      timeoutCall,
      MessengerService.sendMessage,
      action.payload,
      formBody
    );
    if (result.response) {
      if (result.response.status === 200) {
        yield put(initState(formReducerName));
        yield put(
          addItemToUp(
            listReducerName,
            result.destructData.itemId,
            result.destructData.item
          )
        );
      }
    }
    yield put(
      requestFinished(formReducerName, result.status, result.status === 200)
    );
  } catch (error) {
    yield put(requestFinished(formReducerName));
  }
  yield put(requestFinished(formReducerName));
}

export default function* createSaga(reducerName) {
  yield all([
    takeEvery(
      sendRequest(`${reducerName}.sendMessageForm`).type,
      sendMessageFormSaga,
      `${reducerName}`
    )
  ]);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/messenger/reducers/dynamic/roomMessages/sendMessagesForm/sendMessageFormSaga.js